import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import './legal.css'

const AGB = () => {
  return (
    <div className="legal-container">
      <Helmet>
        <title>AGB | Social Media Recruiting Agentur</title>
        <meta name="description" content="Allgemeine Geschäftsbedingungen der Social Media Recruiting Agentur - track by track GmbH für die Erbringung von Agenturleistungen." />
        <meta property="og:title" content="AGB | Social Media Recruiting Agentur" />
      </Helmet>
      
      <Navbar rootClassName="navbarroot-class-name"></Navbar>
      
      <section className="legal-hero-section">
        <div className="legal-hero">
          <div className="legal-hero-content">
            <h1 className="legal-heading">
              Allgemeine Geschäftsbedingungen
            </h1>
            <p className="legal-subtitle">
              AGB der track by track GmbH für die Erbringung von Agenturleistungen
            </p>
          </div>
        </div>
      </section>

      <section className="legal-content-section">
        <div className="legal-content-wrapper">
          <div className="legal-content">
            
            <h2>1. Begriffsbestimmung, Geltungsbereich</h2>
            <ol>
              <li>Diese Allgemeinen Geschäftsbedingungen gelten für alle Gesellschaften der track by track GmbH. Die Begriffe „Auftrag", „Agentur" und „Auftraggeber" sind im kaufmännischen Sinn zu verstehen. „Auftrag" bezeichnet das Vertragsverhältnis ohne Rücksicht auf den jeweiligen Vertragstyp, „Agentur" denjenigen, der die Hauptleistung schuldet, „Auftraggeber" denjenigen, der die Hauptleistung zu erhalten und die Vergütung zu zahlen hat.</li>
              <li>Abweichende Geschäftsbedingungen des Auftraggebers haben nur Gültigkeit, soweit die Agentur sie schriftlich anerkannt hat.</li>
            </ol>

            <hr />

            <h2>2. Termine, Lieferfristen</h2>
            <ol>
              <li>Die vereinbarten Zeitpunkte und Fristen für die Erbringung der Leistungen sind grundsätzlich bindend.</li>
              <li>Die Agentur haftet nicht für Verzögerungen bei der Leistungserbringung, die darauf zurückzuführen sind, dass der Auftraggeber erforderliche Mitwirkungspflichten nicht erfüllt hat.</li>
              <li>Sollte der Auftraggeber sich im Annahmeverzug befinden oder seine Mitwirkungspflichten schuldhaft verletzen, ist die Agentur berechtigt, den daraus entstandenen Schaden einschließlich möglicher Mehraufwendungen ersetzt zu verlangen. Weitergehende Ansprüche bleiben vorbehalten.</li>
            </ol>

            <hr />

            <h2>3. Leistungsumfang, Vergütung</h2>
            <ol>
              <li>Der Umfang der einzelnen Leistungen sowie die dafür zu zahlende Vergütung ergeben sich aus der Leistungsbeschreibung im Angebot der Agentur. Soweit keine Vergütung festgelegt wurde, gelten die zum Zeitpunkt der Beauftragung gültigen Preislisten der Agentur.</li>
              <li>Mehraufwand, insbesondere aufgrund von Änderungs- oder Ergänzungswünschen des Auftraggebers, wird gemäß den vereinbarten Stundensätzen oder Preislisten berechnet.</li>
              <li>Die Agentur darf die ihr obliegenden Leistungen, nach vorheriger Abstimmung mit dem Auftraggeber, auch durch Subunternehmer erbringen lassen. Der Auftraggeber kann diese nur aus wichtigem Grund ablehnen.</li>
              <li>Kündigt der Auftraggeber einen bereits freigegebenen Auftrag vorzeitig, gilt § 649 BGB.</li>
              <li>Die Agentur ist nicht verpflichtet, die in der Werbung enthaltenen, vom Auftraggeber freigegebenen Sachaussagen auf Richtigkeit zu prüfen.</li>
              <li>Die Leistungen der Agentur sind auch dann vertragsgerecht, wenn sie nicht eintragungs- oder schutzfähig sind, sofern nichts anderes vereinbart wurde.</li>
              <li>Mit der Freigabe übernimmt der Auftraggeber die Verantwortung für Inhalt, Bild, Ton und Text.</li>
            </ol>

            <hr />

            <h2>4. Haftung, Gewährleistung</h2>
            <ol>
              <li>Die Agentur haftet bei Vorsatz und grober Fahrlässigkeit nach den gesetzlichen Vorschriften.</li>
              <li>Bei leichter Fahrlässigkeit haftet die Agentur nur bei Verletzung wesentlicher Vertragspflichten (Kardinalpflichten).</li>
              <li>Die Haftung ist in diesem Fall auf vorhersehbare, vertragstypische Schäden begrenzt.</li>
              <li>Die Haftungsbeschränkungen gelten nicht bei Verletzung von Leben, Körper, Gesundheit, bei Arglist, bei Zusicherung von Eigenschaften oder nach dem Produkthaftungsgesetz.</li>
              <li>Die Gewährleistungspflicht beträgt 12 Monate ab Ablieferung.</li>
              <li>Schadensersatz wegen unverschuldeter Irrtümer, Druck- oder Übermittlungsfehler ist ausgeschlossen.</li>
            </ol>

            <hr />

            <h2>5. Abnahme</h2>
            <p>Schuldet die Agentur ein Werk (z. B. Entwurf), ist der Auftraggeber zur Abnahme verpflichtet, wenn es keine oder nur unwesentliche Mängel aufweist.</p>
            <p>Die Abnahme gilt als erfolgt, wenn sie nicht innerhalb von sieben Tagen nach Ablieferung verweigert wird oder wenn das Werk bezahlt oder verwendet wird.</p>

            <hr />

            <h2>6. Rechnung, Preis, Zahlung</h2>
            <ol>
              <li>Die Agentur stellt ihre Leistungen nach Erbringung in Rechnung.</li>
              <li>Zahlungen sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zu leisten.</li>
              <li>Alle Preise verstehen sich netto zzgl. gesetzlicher Umsatzsteuer.</li>
              <li>Aufrechnung und Zurückbehaltungsrechte sind nur bei unbestrittenen oder rechtskräftig festgestellten Ansprüchen zulässig.</li>
            </ol>

            <hr />

            <h2>7. Aufwendungen</h2>
            <ol>
              <li>Jede Partei trägt eigene Kommunikationskosten.</li>
              <li>Reisekosten werden nach Belegen oder der jeweils gültigen Preisliste berechnet (PKW 0,51 €/km).</li>
              <li>Produktions- und Fremdkosten (Location, Models, Requisiten etc.) werden nach Belegen oder Vereinbarung abgerechnet.</li>
              <li>Weitere Auslagen (z. B. Kurier-, Transport- oder Rechtsberatungskosten) werden ebenfalls nach Belegen berechnet.</li>
            </ol>

            <hr />

            <h2>8. Urheberrechtliche Nutzungsrechte / Leistungsschutzrechte</h2>
            <ol>
              <li><strong>Sofern nicht abweichend vereinbart, erwirbt der Auftraggeber mit vollständiger Bezahlung lediglich die für die vereinbarte Vertragslaufzeit erforderlichen, einfachen Nutzungsrechte an den von der Agentur gestalteten Werbemitteln zur Nutzung in den im Vertrag bezeichneten Social-Media-Kanälen.</strong> Nach Ablauf der Vertragslaufzeit endet das Nutzungsrecht automatisch, es sei denn, die Parteien vereinbaren schriftlich eine Verlängerung oder weitergehende Lizenz.</li>
              <li>Eine darüber hinausgehende Nutzung, insbesondere außerhalb der Vertragslaufzeit oder auf weiteren Kanälen (z. B. Print, TV, Out-of-Home), bedarf der ausdrücklichen, schriftlichen Zustimmung der Agentur und ist gesondert zu vergüten.</li>
              <li>Sind zur Erstellung oder Umsetzung von Arbeitsergebnissen Nutzungsrechte Dritter erforderlich, werden diese im Namen und für Rechnung des Auftraggebers eingeholt. Nachforderungen gemäß §§ 32, 32a UrhG gehen zu Lasten des Auftraggebers.</li>
              <li>Die Agentur darf die von ihr konzipierten Werbemittel nach Freigabe zeitlich unbeschränkt zur Eigenwerbung auf ihren Websites, Social-Media-Kanälen und in Präsentationen nutzen. Dies gilt auch für mit ihr verbundene Unternehmen der track by track GmbH.</li>
              <li>Nutzungsrechte an abgelehnten oder nicht ausgeführten Entwürfen verbleiben bei der Agentur.</li>
              <li>Eine Übertragung ausschließlicher, zeitlich und räumlich unbeschränkter Nutzungsrechte erfolgt nur, wenn dies ausdrücklich schriftlich vereinbart und vollständig vergütet wurde.</li>
            </ol>

            <hr />

            <h2>9. Werbeanzeigenmanager und Social-Media-Konten</h2>
            <ol>
              <li>Der Auftraggeber erteilt der Agentur Zugang zu den vereinbarten Werbekonten.</li>
              <li>Die Agentur kann Inhalte posten, hat jedoch keinen Zugriff auf private Nachrichten, es sei denn, dies wird ausdrücklich gestattet.</li>
              <li>Ist die Unterscheidung zwischen von der Agentur oder vom Auftraggeber erstellten Anzeigen technisch nicht möglich, liegt die Haftung für Budgetfehler beim Auftraggeber.</li>
              <li>Die Agentur haftet nicht für Handlungen des Auftraggebers im Zusammenhang mit den Werbekonten, sofern diese nicht auf ausdrückliche Anweisung der Agentur beruhen.</li>
            </ol>

            <hr />

            <h2>10. Besprechungsberichte</h2>
            <p>Die Agentur erstellt innerhalb von drei Arbeitstagen nach jeder Besprechung einen Bericht. Dieser gilt als verbindliche Arbeitsgrundlage, sofern der Auftraggeber nicht innerhalb von fünf Arbeitstagen in Textform widerspricht.</p>

            <hr />

            <h2>11. Schlussbestimmungen</h2>
            <ol>
              <li>Die Unwirksamkeit einzelner Bestimmungen berührt die Gültigkeit der übrigen nicht. Eine unwirksame Bestimmung ist durch eine wirtschaftlich gleichwertige zu ersetzen.</li>
              <li>Änderungen oder Ergänzungen bedürfen der Textform.</li>
              <li>Erfüllungsort und Gerichtsstand ist, soweit gesetzlich zulässig, Berlin.</li>
              <li>Es gilt ausschließlich das Recht der Bundesrepublik Deutschland unter Ausschluss des Internationalen Privatrechts.</li>
            </ol>

          </div>
        </div>
      </section>

      <Footer activePage="agb" />
    </div>
  )
}

export default AGB
